import React, { useState } from "react";
import AdxFormModal from "components/reusable/modal/AdxFormModal";
import Box from "@mui/material/Box";
import EditExpenseForm from "./EditExpenseForm";
import { Typography } from "@mui/material";

const EditExpenseModal = ({
  isEditModalOpen,
  setEditModalOpen,
  reportData,
  expenseData,
  previousSelectedCategory,
  children,
}) => {
  const handleOpen = () => {
    setEditModalOpen(true);
  };
  const handleClose = () => {
    setEditModalOpen(false);
    setSelectedCategory(previousSelectedCategory);
  };
  const [selectedCategory, setSelectedCategory] = useState(
    previousSelectedCategory
  );

  return (
    <Box>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxFormModal
        title={
          <Typography variant="h4" fontWeight="bold" padding={1}>
            Edit expense
          </Typography>
        }
        subtitle={null}
        open={isEditModalOpen}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        handleClose={handleClose}
        disableAutoFocus
        sx={{
          "&.MuiModal-root": { overflowY: "auto" },
          paddingY: { xs: 0, lg: "20px" },
        }}
        sxModal={{
          position: "relative",
          top: { xs: 0, lg: 0 },
          transform: { xs: "translate(-50%, 0)", lg: "translate(-50%, 0)" },
          width: { xs: 1, lg: "750px" },
          borderRadius: {
            xs: 0,
            lg: "20px",
          },
        }}
      >
        <EditExpenseForm
          reportData={reportData}
          expenseData={expenseData}
          handleClose={handleClose}
          setEditModalOpen={setEditModalOpen}
          selectedCategory={selectedCategory}
          previousSelectedCategory={previousSelectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      </AdxFormModal>
    </Box>
  );
};

export default EditExpenseModal;
